import {showErrorNotification} from "../../global/notifications";

let _waiverNumber = $('#RequestNumber').val();

export default function () {
    saveEvent();
    approvalEvent();
    rejectionEvent();
    downloadEvent();
}

const saveEvent = () => {
    let $submitButton = $('button[type="submit"]');
    $submitButton.unbind('click');
    $submitButton.bind('click', function () {
        $submitButton.attr("disabled", true);
        if (_waiverNumber === '0' || $submitButton.data('role') !== 'edit') {
            if (checkFormValidation()) {
                submitRequest()
                    .then(requestNumber => loadDisplayPage(requestNumber))
                    .then(_ => $.event.trigger('on:BundleReady'))
                    .then(_ => $.event.trigger('on:AttachmentLoad'))
                    .catch(error => showErrorNotification(error))
                    .finally(_ => {
                        $submitButton.attr("disabled", true);
                    });
            } else {
                showErrorNotification("Please complete all required fields.");
                $submitButton.attr("disabled", false);
            }
        } else {
            loadEditPage(_waiverNumber)
                .then(_ => $.event.trigger('on:BundleReady'))
                .then(_ => $.event.trigger('on:AttachmentLoad'))
                .catch(error => showErrorNotification(error))
                .finally(_ => {
                    $submitButton.attr("disabled", true);
                });
        }

        return false;
    })
}

const submitRequest = () => {
    return new Promise((resolve, reject) => {
        $.post('/Operations/BondWaiverRequest/SubmitWaiverRequest', $('form').serialize(), function (response) {
            if (response.success) {
                resolve(response.RequestNumber);
            } else {
                reject(response.message);
            }
        })
    })
}

const loadDisplayPage = (requestId) => {
    return new Promise((resolve, reject) => {
        $('form').load('/Operations/BondWaiverRequest/LoadRequestDisplay', {requestId: requestId}, function (response) {
            resolve();
            approvalEvent();
            rejectionEvent();
            saveEvent();
        });
    });
}

const loadEditPage = (requestId) => {
    return new Promise((resolve, reject) => {
        $('form').load('/Operations/BondWaiverRequest/LoadRequestEdit', {requestId: requestId}, function (response) {
            resolve();
            bondWaiverRequestElements();
            saveEvent();
        });
    });
}

const checkFormValidation = () => {
    $('.fieldValidationError').removeClass('fieldValidationError').removeClass('bg-danger-light');
    const requiredFields = $('[data-required]');
    let pass = true;

    $.each(requiredFields, function (index, ele) {
        const $ele = $(ele);
        if ($ele.val() === "") {
            pass = false;
            if ($ele.hasClass('k-textbox')) {
                $ele.addClass("fieldValidationError");
            } else {
                $ele.parent().addClass("fieldValidationError");
            }
        }
    })

    const $attachmentContainer = $('div[name=audited-statement]');
    const $attachments = $attachmentContainer.find('.k-file.k-file-success');
    if ($attachments.length < 1) {
        pass = false;
        $attachmentContainer.addClass("fieldValidationError").addClass('bg-danger-light');
    }

    return pass;
}

const approvalEvent = () => {
    const $approvalButton = $('button[data-role="approve"]');
    if ($approvalButton.length) {
        $approvalButton.unbind('click');
        $approvalButton.bind('click', function () {
            approveRequest()
                .then(requestNumber => loadApprovals(requestNumber))
                .catch(error => showErrorNotification(error));
        });
    }
}

const approveRequest = () => {
    return new Promise((resolve, reject) => {
        let data = {
            RequestNumber: $('#RequestNumber').val(),
            pin: $('[name="pin"]').val(),
            comment: $('[name="comment"]').val(),
            role: $('[name="role"]').val()
        };
        $.post('/Operations/BondWaiverRequest/ApproveRequest', data, function (response) {
            if (response.success) {
                resolve(data.RequestNumber);
            } else {
                reject(response.message);
            }
        });
    });
}

const rejectionEvent = () => {
    const $rejectButton = $('button[data-role="reject"]');
    if ($rejectButton.length) {
        $rejectButton.unbind('click');
        $rejectButton.bind('click', function () {
            rejectRequest()
                .then(requestNumber => loadApprovals(requestNumber))
                .catch(error => showErrorNotification(error));
        });
    }
}

const rejectRequest = () => {
    return new Promise((resolve, reject) => {
        let data = {
            RequestNumber: $('#RequestNumber').val(),
            pin: $('[name="pin"]').val(),
            comment: $('[name="comment"]').val(),
            role: $('[name="role"]').val()
        };
        $.post('/Operations/BondWaiverRequest/RejectRequest', data, function (response) {
            if (response.success) {
                resolve(data.RequestNumber);
            } else {
                reject(response.message);
            }
        });
    });
}

const loadApprovals = (requestNumber) => {
    $('#approval_section').load('/Operations/BondWaiverRequest/LoadRequestApprovals', {requestNumber: requestNumber}, function (response) {
        const $footer = $('.form-footer.form-footer--js');
        if ($footer.length) {
            $footer.remove();
        }
        approvalEvent();
        rejectionEvent();
        $.event.trigger('on:BundleReady');
    });
}

const $downloadButton = $('.js-pdf-download');
const downloadEvent = () => {
    const id = $downloadButton.data('id');
    $downloadButton.prop('href', `/Operations/BondWaiver/DownloadReport/${id}`)
};